// extracted by mini-css-extract-plugin
module.exports = {"ssa0lg7":"ssa0lg7","swzn2rm":"swzn2rm"};